export const columns = [
  {
    Header: 'Bolsillo NN',
    accessor: 'sEmpleado',
  },
  {
    Header: 'RUT',
    accessor: 'sRUT',
    type: 'dni',
  },
  {
    Header: 'Número de bolsillo',
    accessor: 'sTarjeta',
    type: 'card',
  },
  {
    Header: 'Nombre',
    accessor: 'sNombre',
  },
  {
    Header: 'Primer Apellido',
    accessor: 'sApellidoPaterno',
  },
  {
    Header: 'Segundo apellido',
    accessor: 'sApellidoMaterno',
  },
  {
    Header: 'Saldo',
    accessor: 'nSaldo',
    type: 'currency',
    editable: false,
  },
  {
    Header: 'Estado Cuenta',
    accessor: 'sEstado',
    type: 'status',
  },
  {
    Header: 'Estado Bolsillo',
    accessor: 'sEstadoTarjeta',
    type: 'statusCard',
  },
]

export const data = [
  {
    dni: '12312313',
    card_number: '123-123123-123',
    name: 'algo',
    last_name: 'algo',
    surname: 'algo',
    balance: '100000',
    status: 'Activo',
  },
  {
    dni: '12312313',
    card_number: '123-123123-123',
    name: 'algo',
    last_name: 'algo',
    surname: 'algo',
    balance: '100000',
    status: 'Activo',
  },
  {
    dni: '12312313',
    card_number: '123-123123-123',
    name: 'algo',
    last_name: 'algo',
    surname: 'algo',
    balance: '100000',
    status: 'Activo',
  },
  {
    dni: '12312313',
    card_number: '123-123123-123',
    name: 'algo',
    last_name: 'algo',
    surname: 'algo',
    balance: '100000',
    status: 'Activo',
  },
  {
    dni: '12312313',
    card_number: '123-123123-123',
    name: 'algo',
    last_name: 'algo',
    surname: 'algo',
    balance: '100000',
    status: 'Activo',
  },
]
